var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6 9.6H7.8V10.9H2.6V9.6ZM2.6 7H7.8V8.3H2.6V7ZM6.5 0.5H1.3C0.585 0.5 0 1.085 0 1.8V12.2C0 12.915 0.5785 13.5 1.2935 13.5H9.1C9.815 13.5 10.4 12.915 10.4 12.2V4.4L6.5 0.5ZM9.1 12.2H1.3V1.8H5.85V5.05H9.1V12.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.811d5cc9ddf0814f782cd1e8b225655f.svg";
export { ForwardRef as ReactComponent };